import React from "react"

// Styles
import headerCircleStyles from "./HeaderCircle.module.styl"

const HeaderCircle = () => <i className={headerCircleStyles.HeaderCircle}></i>

export default HeaderCircle
